// Service envia estado del sidebar para adaptar tamaño de componentes.html
import { Injectable, Output, EventEmitter, Directive } from '@angular/core';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class SideBarService {

  isOpen = false;
  @Output() change: EventEmitter<boolean> = new EventEmitter();

  toggle(sideBarFull) {
    sideBarFull = !sideBarFull;
    this.change.emit(sideBarFull);
  }
}
